import { Box } from '@mui/material'
import { useRightPanel } from '@/core/right-panel/RightPanelContext'
import { useDiRef, useTransientDiRef } from '@/common/react/di-hooks'
import type { ObjectTypesService } from '../services/ObjectTypesService'
import { TypeForm } from '../type-form/TypeForm'
import type { EditTypeController } from '../type-form/EditTypeController'
import '../create-type-page/CreateObjectTypePage.css'

interface EditTypePanelPageProps {
  typeId: number
}

export function EditTypePanelPage({ typeId }: EditTypePanelPageProps) {
  const { closePanel } = useRightPanel()
  const objectTypesService = useDiRef<ObjectTypesService>('ObjectTypesService')

  const type = objectTypesService.getTypeFromSelectedSpace(typeId)

  const controller = useTransientDiRef<EditTypeController>('EditTypeController', (c) => {
    if (type) c.init({ type, closePanel })
  })

  if (!type) return null

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        p: 2,
        overflow: 'hidden auto',
      }}
    >
      <TypeForm
        label="Edit type:"
        initialName={type.name}
        compact
        submitLabel="Save"
        controller={controller}
      />
    </Box>
  )
}
